import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=154d4b40&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"
import style0 from "./Photos.vue?vue&type=style&index=0&id=154d4b40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d4b40",
  null
  
)

export default component.exports